import React, { useState } from 'react';
import { SectionWrapper } from './ui';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const AccordionItem = ({
  question,
  answer
}: {
  question: string;
  answer: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-dark-border" data-id="element-18">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-6 flex items-center justify-between text-left focus:outline-none group" data-id="element-19">
        <span className="text-lg md:text-xl font-bold text-white group-hover:text-primary transition-colors pr-4" data-id="element-20">
          {question}
        </span>
        <span className="text-primary shrink-0" data-id="element-21">
          {isOpen ? <ChevronUpIcon size={24} data-id="element-22" /> : <ChevronDownIcon size={24} data-id="element-23" />}
        </span>
      </button>
      <AnimatePresence data-id="element-24">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-25">
            <p className="pb-6 text-gray-400 text-lg leading-relaxed" data-id="element-26">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
};
export const FAQ = () => {
  const faqs = [{
    q: '¿Sirve si recién estoy empezando?',
    a: 'Sí. El kit te da el sistema correcto desde el día uno.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'En menos de 5 minutos tenés el link de acceso en tu correo.'
  }, {
    q: '¿Necesito ser veterinario para el tomo de primeros auxilios?',
    a: 'No. Los protocolos son visuales, claros y paso a paso.'
  }, {
    q: '¿Funciona para gatos también?',
    a: 'Sí. Todos los tomos tienen secciones específicas para felinos.'
  }];
  return <SectionWrapper className="bg-dark-bg" data-id="element-27">
      <div className="max-w-3xl mx-auto" data-id="element-28">
        <div className="text-center mb-12" data-id="element-29">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-4" data-id="element-30">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>
        </div>

        <div className="bg-dark-card border border-dark-border rounded-2xl p-6 md:p-8 shadow-xl" data-id="element-31">
          {faqs.map((faq, i) => <AccordionItem key={i} question={faq.q} answer={faq.a} data-id="element-32" />)}
        </div>
      </div>
    </SectionWrapper>;
};